import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-settings-layout',
  templateUrl: './settings-layout.component.html',
  styleUrls: ['./settings-layout.component.scss'],
})
export class SettingsLayoutComponent {
  @Input() menuType: string = 'admin';
  @Input() showSidebar: boolean = true;
  @Input() fullWidthClass: string = 'col-12';
}
